import { LayoutConfig } from 'config/layout'
import { GameDetail } from 'config/types/game'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import AdditionalContent from 'layout/Components/AdditionalContent'
import { ColumnCenter } from 'layout/Components/Column'
import Footer from 'layout/Components/Footer'
import React from 'react'
import { useAppStatus } from 'state/app/hooks'
import styled from 'styled-components'
import theme from 'theme'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import GameDesktopIframePopup from 'views/GameDetails/GameDesktopIframePopup'
import { CONTENT_LEVEL } from './config'

const DesktopGameScreen = ({ gameDetail, ...props }: { gameDetail?: GameDetail }) => {
  const { isMobile } = useMatchBreakpoints()
  return !isMobile && <GameDesktopIframePopup gameDetail={gameDetail} {...props} />
}

const MainContentLayout: React.FC<{ children: React.ReactNode; layoutConfig?: LayoutConfig }> = ({
  children,
  layoutConfig,
}) => {
  return (
    <ColumnCenter
      // If you change this id, make sure to update all related logic or selectors that depend on "app-content".
      id="app-content"
      marginTop={[!layoutConfig?.header?.mobile?.hidden ? '64px' : '0px', , '0px']}
      paddingBottom={[
        layoutConfig?.bottomBar?.mobile?.hidden ? '0px' : `${theme.bottombarHeight}`,
        ,
        layoutConfig?.bottomBar?.tablet?.hidden ? '0px' : `${theme.bottombarHeight}`,
        '0px',
      ]}
      height={[
        'auto',
        ,
        !layoutConfig?.header?.tablet?.hidden
          ? 'calc(calc(100% - 64px) - var(--notification-bar-height))'
          : 'calc(100% - var(--notification-bar-height))',
        ,
        !layoutConfig?.header?.desktop?.hidden
          ? 'calc(calc(100% - 64px) - var(--notification-bar-height))'
          : 'calc(100% - var(--notification-bar-height))',
      ]}
      minHeight="0"
      overflowY="auto"
      position="relative"
      zIndex={CONTENT_LEVEL}
    >
      {children}

      <StyledFooter
        display={[
          !layoutConfig?.footer?.mobile?.hidden ? 'block' : 'none',
          ,
          !layoutConfig?.footer?.tablet?.hidden ? 'block' : 'none',
          ,
          !layoutConfig?.footer?.desktop?.hidden ? 'block' : 'none',
        ]}
      >
        <Box margin="0 auto">
          <Footer />
        </Box>
      </StyledFooter>
    </ColumnCenter>
  )
}

type MainContentProps = {
  children: React.ReactNode
  layoutConfig?: LayoutConfig
  htmlContent?: string
} & BoxProps

const MainContent: React.FC<MainContentProps> = ({ children, layoutConfig, htmlContent, maxWidth, ...props }) => {
  const { isFinishFetch } = useAppStatus()

  return (
    <MainContentLayout layoutConfig={layoutConfig}>
      {isFinishFetch && (
        <Box maxWidth={maxWidth} width="100%">
          <DesktopGameScreen {...props} />
          {children}
          {htmlContent && <AdditionalContent htmlContent={htmlContent} />}
        </Box>
      )}
    </MainContentLayout>
  )
}

const StyledFooter = styled(Box)`
  width: 100%;
  background: ${(props) => props.theme.colors.background};
`

export default MainContent
